module.exports = __webpack_public_path__ + "images/ab1b9d84.awardCoin.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/awardDialog/images/awardCoin.webp
// module id = DNa7
// module chunks = 12